<template>
  <el-dialog :close-on-click-modal="false" custom-class="qr" :visible.sync="visibleInner" append-to-body>
    <qr-code :text="text"></qr-code>
  </el-dialog>
</template>

<script>
export default {
  name: 'qr-code-modal',
  props: ['text', 'visible'],
  computed: {
    visibleInner: {
      get () {
        return this.visible
      },
      set (val) {
        if (!val) {
          this.$emit('update:visible', false)
        }
      }
    }
  }
}
</script>
<style>
.el-dialog.qr {
  width: 300px;
}

.el-dialog.qr .el-dialog__headerbtn {
  top: 10px;
  right: 10px;
}

.el-dialog.qr .el-dialog__header {
  padding: 0;
}
.el-dialog.qr .el-dialog__body {
  padding: 20px;
}
</style>
